<template>
  <div class="order-import-excel">
    <b-modal
      id="import-excel-create-orders"
      ref="import-excel-create-orders"
      hide-footer
      title="Nhập excel đơn hàng:"
      no-close-on-backdrop
      size="xl"
    >
      <div>
        <b-row>
          <b-col>
            <div class="form-group">
              <span>
                <b>Bước 1:</b> Vui lòng chuẩn bị dữ liệu mẫu từ file excel đúng
                format, hoặc có thể tải ở
                <a :href="urlExcel">template tạo mới</a>
                hoặc ở
                <a :href="urlExcelTracking">template cập nhật</a>
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12" md="4">
            <span>
              <b>Bước 2:</b> Vui lòng chọn 'Loại' trước khi Import File Excel
            </span>
            <div style="padding-top: 15px">
              <b-form-group>
                <b-form-select
                  v-model="importType"
                  :options="importTypeOptions"
                  @change="onImportTypeChange"
                ></b-form-select>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span> <b>Bước 3:</b> Tiến hành Import </span>
            <div style="padding-top: 15px">
              <b-form-file
                @change="selectFile"
                v-model="file"
                ref="file-input"
                style="display: none"
                id="file-input"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              ></b-form-file>
              <b-input-group>
                <b-input-group-prepend>
                  <b-button
                    :disabled="btnDisable"
                    variant="secondary"
                    @click="openFile('file-input')"
                    v-b-tooltip.hover
                    title="Chọn file"
                    ><i class="fas fa-paperclip"></i
                  ></b-button>
                </b-input-group-prepend>

                <b-form-input
                  type="text"
                  :disabled="btnDisable"
                  v-model="textFile"
                  placeholder="Hãy chọn một tập tin"
                  @click="openFile('file-input')"
                  v-on:keydown.prevent
                  style="caret-color: transparent; cursor: pointer"
                  autocomplete="off"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="secondary"
                    :disabled="!file"
                    v-b-tooltip.hover
                    @click="uploadFile"
                    title="Tải file"
                    ref="up_excel"
                  >
                    <i class="fas fa-upload text-primary"></i>
                  </b-button>
                  <b-button
                    variant="secondary"
                    :disabled="!file"
                    @click="clearFiles"
                    v-b-tooltip.hover
                    title="Xoá file"
                    ><i class="fas fa-trash text-danger"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
              <label class="description" style="font-size: 10px">
                Chỉ nhận file csv, xls, xlsx và nhỏ hơn 5MB</label
              >
            </div>
            <div v-show="file" class="mt-4">
              <b-progress :max="100">
                <b-progress-bar
                  :value="processBar"
                  :label="`${processBar.toFixed(2)}%`"
                ></b-progress-bar>
              </b-progress>
            </div>
          </b-col>
        </b-row>
        <!-- End input session -->
      </div>

      <div
        class="mt-10"
        v-show="importType === 'create' && importItems.length !== 0"
      >
        <hr
          class="hr-text"
          data-content="Danh sách đơn hàng"
          style="font-weight: 600"
        />
        <div class="title-sum">
          <ul class="list-inline d-flex">
            <li>
              <b
                >Tổng tiền:
                <span class="text-success">{{ formattedTotalPrice }}</span>
              </b>
            </li>
          </ul>
        </div>
        <b-table
          class="myTable"
          caption-top
          responsive
          bordered
          hover
          :fields="fields"
          :items="importItems"
          id="my-table"
          :per-page="10"
          :current-page="currentPage"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle ml-3"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(codeShipName)="data">
            <p>{{ data.item.codeShip }}</p>
          </template>
          <template v-slot:cell(orderSn)="data">
            <p>{{ data.item.orderSn }}</p>
          </template>
          <template v-slot:cell(customerName)="data">
            <b> {{ data.item.customerName }}</b>
            <p>{{ data.item.customerMobile }}</p>
            <span v-if="data.item.customerAddress">
              <b>ĐC:</b> {{ data.item.customerAddress }}
            </span>
          </template>
          <template v-slot:cell(productName)="data">
            <div v-if="!data.item.orderItems">
              <span class="font-weight-bolder">{{
                data.item.productName
              }}</span>
            </div>
            <div v-else>
              <div v-for="(item, idx) in data.item.orderItems" :key="idx">
                <p class="font-weight-bolder">
                  <span v-if="item.stt === -1"
                    >&emsp;<i class="fas fa-gift"></i
                  ></span>
                  <span v-else>{{ item.stt }}</span>
                  {{ item.productName }}
                </p>
                <div class="d-flex justify-content-between px-2 my-2">
                  <div>
                    Giá: {{ convertPrice(item.sellingPrice) }}
                    <p
                      v-b-tooltip.hover.bottom
                      title="Chiết khấu sản phẩm"
                      v-if="item.discountAmount"
                    >
                      <i
                        class="fa fa-arrow-down icon-color"
                        style="font-size: 12px; text-align: center"
                      >
                      </i
                      >:
                      <span class="font-weight-bolder text-warning">
                        {{ convertPrice(item.discountAmount) }}
                      </span>
                    </p>
                  </div>
                  <span>SL: {{ item.quantity }}</span>
                </div>
              </div>
            </div>
          </template>
          <template v-slot:cell(amountTotal)="data">
            <p v-show="data.item.customerShipFee > 0" class="border-0">
              <i
                v-b-tooltip.hover
                title="Phí ship"
                class="fas fa-shipping-fast icon-color"
              ></i>
              : {{ convertPrice(data.item.customerShipFee) }}
            </p>
            <p v-show="data.item.shipFee > 0" class="border-0">
              <i
                v-b-tooltip.hover
                title="Phí trả hãng vận chuyển"
                class="fas fa-hand-holding-usd icon-color"
              ></i>
              : {{ convertPrice(data.item.shipFee) }}
            </p>
            <p v-show="data.item.discountAmount > 0" class="border-0">
              <i
                v-b-tooltip.hover
                title="Chiết khấu"
                class="fa fa-arrow-down icon-color"
              ></i>
              : {{ convertPrice(data.item.discountAmount) }}
              <span v-if="data.item.discountType === 2"> % </span>
            </p>
            <b style="color: #2e7d32">
              {{ convertPrice(sumAmountTotal(data.item)) }}
            </b>
          </template>

          <template v-slot:cell(note)="data">
            <p v-if="data.item.saleNote && data.item.saleNote.trim()">
              <span class="font-weight-bold">Từ CSKH:</span>
              {{ data.item.saleNote }}
            </p>
            <p v-if="data.item.customerNote && data.item.customerNote.trim()">
              <span class="font-weight-bold">Từ khách:</span>
              {{ data.item.customerNote }}
            </p>
          </template>

          <template #cell(statusValidate)="data">
            <div v-if="!data.item.onLoading">
              <div class="d-table-cell align-middle" style="width: 10%">
                <i
                  v-b-tooltip.hover
                  :title="htmlGetStatusValidate(data.item, 'title')"
                  :class="htmlGetStatusValidate(data.item, 'class')"
                ></i>
              </div>
              <div class="d-block align-middle pb-1 pl-2" style="width: 90%">
                <div v-for="(items, i) in data.item.errors" :key="i">
                  <span class="text-danger">{{ items }}</span>
                </div>
              </div>
              <div
                class="d-table-cell align-middle pb-1 pl-2"
                style="width: 90%"
              >
                {{ data.item.statusValidateName }}
              </div>
            </div>
            <div v-else>
              <b-spinner small variant="primary" class="mr-2"></b-spinner>
              <span class="text-primary">Đang xử lí...</span>
            </div>
          </template>

          <template #cell(actions)="row">
            <v-icon
              v-if="!hasError || successCreateOrder"
              small
              class="text-danger"
              @click="onRemovedItem(row.item.orderCode)"
              v-b-tooltip
              title="Xóa"
              >mdi-delete</v-icon
            >
          </template>
        </b-table>
        <b-col class="row mt-3">
          <b>
            Tổng số dòng:
            {{ importItems ? importItems.length : 0 }}
          </b>
        </b-col>
        <b-pagination
          v-show="importItems.length > 10"
          v-model="currentPage"
          :total-rows="rows()"
          :per-page="10"
          aria-controls="my-table"
          align="right"
        ></b-pagination>
      </div>
      <div
        class="mt-10"
        v-show="importType === 'update' && updateItems.length !== 0"
      >
        <hr
          class="hr-text"
          data-content="Danh sách cập nhật"
          style="font-weight: 600"
        />
        <b-table
          class="myTable"
          caption-top
          responsive
          bordered
          hover
          :fields="fieldsUpdate"
          :items="updateItems"
          id="my-table-update"
          :per-page="10"
          :current-page="currentPageUpdate"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle ml-3"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template v-slot:cell(idOrder)="data">
            <span>{{ data.item.idOrder }}</span>
          </template>

          <template v-slot:cell(codeShipName)="data">
            <span>
              {{ data.item.codeShipName }}
            </span>
          </template>
          <template #cell(statusValidate)="data">
            <div v-if="!data.item.onLoading">
              <div class="d-table-cell align-middle" style="width: 10%">
                <i
                  v-b-tooltip.hover
                  :title="htmlGetStatusValidate(data.item, 'title', 'create')"
                  :class="htmlGetStatusValidate(data.item, 'class', 'create')"
                ></i>
              </div>
              <div class="d-block align-middle pb-1 pl-2" style="width: 90%">
                <div v-for="(items, i) in data.item.errors" :key="i">
                  <span class="text-danger">{{ items }}</span>
                </div>
              </div>
              <div
                class="d-table-cell align-middle pb-1 pl-2"
                style="width: 90%"
              >
                {{ data.item.statusValidateName }}
              </div>
            </div>
            <div v-else>
              <b-spinner small variant="primary" class="mr-2"></b-spinner>
              <span class="text-primary">Đang xử lí...</span>
            </div>
          </template>

          <template #cell(statusValidateUpdate)="data">
            <div
              v-if="!data.item.onLoading"
              class="d-flex flex-column align-items-center justify-content-center h-100"
            >
              <i
                v-b-tooltip.hover
                :title="htmlGetStatusValidate(data.item, 'title', 'update')"
                :class="htmlGetStatusValidate(data.item, 'class', 'update')"
                style="font-size: 1.5rem"
                class="mb-1"
              ></i>
              <div
                v-if="data.item.errors && data.item.errors.length > 0"
                class="mt-1 text-center"
              >
                <div v-for="(err, idx) in data.item.errors" :key="idx">
                  <small class="text-danger">{{ err }}</small>
                </div>
              </div>
            </div>
            <div
              v-else
              class="d-flex flex-column align-items-center justify-content-center h-100"
            >
              <b-spinner small variant="primary" class="mb-1"></b-spinner>
              <span class="text-primary">Đang xử lí...</span>
            </div>
          </template>

          <template #cell(actions)="row">
            <v-icon
              v-if="!hasErrorUpdate || successUpdateOrder"
              small
              class="text-danger"
              @click="onRemovedUpdateItem(row.item.idOrder)"
              v-b-tooltip
              title="Xóa"
              >mdi-delete</v-icon
            >
          </template>
        </b-table>
        <b-col class="row mt-3">
          <b>
            Tổng số dòng:
            {{ updateItems ? updateItems.length : 0 }}
          </b>
        </b-col>
        <b-pagination
          v-show="updateItems.length > 10"
          v-model="currentPageUpdate"
          :total-rows="updateRows()"
          :per-page="10"
          aria-controls="my-table-update"
          align="right"
        ></b-pagination>
      </div>

      <!-- Action Buttons -->
      <div class="mt-4 d-flex justify-content-start">
        <b-overlay
          v-if="showOverlay(importType)"
          :show="getLoading(importType)"
          rounded
          opacity="0.6"
          class="d-inline-block mr-3"
        >
          <template #overlay>
            <div class="d-flex align-items-center">
              <b-spinner variant="light" small type="grow"></b-spinner>
            </div>
          </template>

          <b-button
            style="width: 80px"
            class="mt-6"
            :disabled="getLoading(importType) || !getItems(importType).length"
            v-if="getItems(importType).length && !getSuccess(importType)"
            variant="primary"
            size="sm"
            @click="handleSubmit(importType)"
          >
            <strong>{{
              importType === 'create' ? 'Tạo mới' : 'Cập nhật'
            }}</strong>
          </b-button>
        </b-overlay>

        <b-button
          class="mt-6"
          style="width: 80px"
          variant="secondary"
          size="sm"
          @click="hideModalExcel"
        >
          <strong>Hủy</strong>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { EventBus } from '@/core/services/event-bus';
import { BASE_URL } from '@/utils/constants';
import { cloneDeep, convertPrice, delay } from '@/utils/common';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import * as ENUM_NAME from '@/utils/enum-name';
import * as ENUM from '@/utils/enum';
import ApiService from '@/core/services/api.service';
import { URL_IMPORT_ORDER } from '../../../utils/constants';

const STATUS_VALIDATE = {
  INVALID: 0,
  VALID: 1,
  READY: 2,
  LOADING: 3,
};

const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  width: '5%',
};

export default {
  name: 'OrderImportExcel',
  data() {
    return {
      ENUM,
      ENUM_NAME,
      urlExcel: URL_IMPORT_ORDER.ORDER_CREATE,
      urlExcelTracking: URL_IMPORT_ORDER.ORDER_UPDATE,
      importType: 'create',
      importTypeOptions: [
        { value: 'create', text: 'Tạo mới' },
        { value: 'update', text: 'Cập nhật' },
      ],
      // Create order data
      onLoadingList: false,
      currentPage: 1,
      importItems: [],
      successCreateOrder: false,
      // Update order data
      onLoadingListUpdate: false,
      currentPageUpdate: 1,
      updateItems: [],
      successUpdateOrder: false,
      file: null,
      btnDisable: false,
      processBar: 0,
      tempImportItems: [],
      textFile: '',
      isBusy: false,

      fields: [
        {
          key: 'orderCode',
          label: 'ID',
          thStyle: {
            ...thStyleCommon,
            width: '5%',
          },
          formatter: (value) => {
            return `#${value}`;
          },
          tdClass: 'align-middle',
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          thStyle: {
            ...thStyleCommon,
            width: '5%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'orderSourceName',
          label: 'Nguồn',
          thStyle: {
            ...thStyleCommon,
            width: '5%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'orderTypeName',
          label: 'Loại đơn hàng',
          thStyle: {
            ...thStyleCommon,
            width: '5%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'codeShipName',
          label: 'Mã vận đơn',
          thStyle: {
            ...thStyleCommon,
            width: '10%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'orderSn',
          label: 'Mã đơn từ sàn',
          thStyle: {
            ...thStyleCommon,
            width: '10%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'customerName',
          label: 'Khách hàng',
          thStyle: {
            ...thStyleCommon,
            width: '10%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: {
            ...thStyleCommon,
            width: '30%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'amountTotal',
          label: 'Tổng tiền',
          thStyle: {
            ...thStyleCommon,
            width: '10%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'note',
          label: 'Ghi chú',
          thStyle: {
            ...thStyleCommon,
            width: '7%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'statusValidate',
          label: 'Trạng thái',
          thStyle: {
            ...thStyleCommon,
            width: '15%',
          },
          tdClass: 'align-middle text-center',
        },
        {
          key: 'actions',
          label: '',
          tdClass: 'align-middle text-center',
        },
      ],

      fieldsUpdate: [
        {
          key: 'idOrder',
          label: 'ID Đơn hàng',
          thStyle: { ...thStyleCommon, width: '25%' },
          tdClass: 'align-middle text-center',
        },
        {
          key: 'codeShipName',
          label: 'Mã vận đơn',
          thStyle: { ...thStyleCommon, width: '25%' },
          tdClass: 'align-middle text-center',
        },
        {
          key: 'statusValidateUpdate',
          label: 'Lỗi',
          thStyle: { ...thStyleCommon, width: '30%' },
          tdClass: 'align-middle text-left',
        },
        { key: 'actions', label: '', tdClass: 'align-middle text-center' },
      ],
    };
  },
  mounted() {
    EventBus.$on('popup-import-orders', this.popupImportExcelCreateOrder);
  },
  beforeDestroy() {
    EventBus.$off('popup-import-orders', this.popupImportExcelCreateOrder);
  },
  computed: {
    hasError() {
      return this.hasErrorImport(this.importItems);
    },
    hasErrorUpdate() {
      return this.hasErrorImport(this.updateItems);
    },
    formattedTotalPrice() {
      if (!this.importItems || this.importItems.length === 0)
        return this.convertPrice(0);
      let totalPrice = 0;
      this.importItems.map((item) => {
        const orderItemType = item.productType;
        if (orderItemType !== ENUM.ITEM_TYPE.GIFT) {
          const totalPriceItem = this.sumAmountTotal(item);
          totalPrice += totalPriceItem;
        }
      });
      return this.convertPrice(totalPrice);
    },
  },
  methods: {
    delay,
    convertPrice,

    onImportTypeChange() {
      this.clearFiles();
      this.importItems = [];
      this.updateItems = [];
      this.successCreateOrder = false;
      this.successUpdateOrder = false;
    },

    hasErrorImport(list) {
      if (!list || list.length === 0) return false;
      const errors = list.map((item) => item.errors || []).flat();
      return errors.length > 0;
    },

    hideModalExcel() {
      this.$refs['import-excel-create-orders'].hide();
      this.clearFiles();
    },

    onCreateOrders: async function () {
      const items = cloneDeep(this.importItems);
      const invalids = items.filter((item) => item.errors.length > 0);

      if (invalids.length > 0) {
        return this.makeToastFaile(
          `Đơn hàng không hợp lệ
            ${invalids.map((item) => item.orderCode).join()}`,
        );
      }

      if (!this.isBusy) {
        const dataMessages = {
          success: [],
          failed: [],
        };

        for (const item of items) {
          const index = this.importItems.findIndex(
            (e) => e.orderCode === item.orderCode,
          );

          if (index < 0) {
            this.makeToastFaile('Không tìm thấy đơn hàng.');
            return;
          }

          this.importItems[index].onLoading = true;
          // Kiểm tra và bỏ qua các phần tử có productType = 2 (sp quà tặng)
          item.orderItems = item.orderItems.filter(
            (orderItem) => orderItem.productType !== ENUM.ITEM_TYPE.GIFT,
          );

          const [status, message] = await ApiService.post('/orders/v2', item)
            .then((response) => {
              const { status, message } = response.data;
              return [status, message];
            })
            .catch((err) => {
              if (!err.response) {
                // network error
                return [0, 'Lỗi mạng'];
              } else {
                const message = err.response.data.message;
                return [0, message];
              }
            });

          this.importItems[index].onLoading = false;

          if (status) {
            dataMessages.success.push(item);
            this.importItems[index].statusValidate = STATUS_VALIDATE.VALID;
            this.importItems[index].statusValidateName = 'Tạo mới thành công';
          } else {
            this.importItems[index].statusValidate = STATUS_VALIDATE.INVALID;
            this.importItems[index].statusValidateName = message;
          }
        }

        if (dataMessages.success.length === this.importItems.length) {
          this.makeToastSuccess('Tạo đơn hàng thành công');
          this.successCreateOrder = true;
          this.$emit('refresh', true);
        } else {
          this.makeToastFaile('Đơn hàng cập nhật thất bại');
          this.$emit('refresh', true);
        }
      }
    },
    onUpdateOrders: async function () {
      const items = cloneDeep(this.updateItems);
      const invalids = items.filter((item) => item.errors.length > 0);

      if (invalids.length > 0) {
        return this.makeToastFaile(
          `Đơn hàng không hợp lệ ${invalids
            .map((item) => item.idOrder)
            .join()}`,
        );
      }

      if (!this.isBusy) {
        this.onLoadingListUpdate = true;

        // Payload gửi sang BE (mảng)
        const payload = items.map((item) => ({
          id: item.idOrder,
          codeShip: item.codeShipName,
        }));

        const [status, message, result] = await ApiService.put(
          'orders/update-import-excel',
          payload,
        )
          .then((response) => {
            const { status, message, data } = response.data;
            return [status, message, data];
          })
          .catch((err) => {
            if (!err.response) {
              return [0, 'Lỗi mạng', null];
            } else {
              const message = err.response.data.message;
              return [0, message, null];
            }
          });

        this.onLoadingListUpdate = false;

        if (status && result) {
          // Cập nhật trạng thái UI cho successes
          result.successes.forEach((s) => {
            const idx = this.updateItems.findIndex((e) => e.idOrder === s.id);
            if (idx >= 0) {
              this.updateItems[idx].statusValidate = STATUS_VALIDATE.VALID;
              this.updateItems[idx].statusValidateName = 'Cập nhật thành công';
            }
          });

          // Cập nhật trạng thái UI cho failures
          result.failures.forEach((f) => {
            const idx = this.updateItems.findIndex((e) => e.idOrder === f.id);
            if (idx >= 0) {
              this.updateItems[idx].statusValidate = STATUS_VALIDATE.INVALID;
              this.updateItems[idx].statusValidateName = f.errors.join(', ');
              this.updateItems[idx].errors = f.errors || [];
            }
          });

          if (result.failures.length === 0) {
            this.makeToastSuccess('Cập nhật đơn hàng thành công');
            this.successUpdateOrder = true;
            this.$emit('refresh', true);
          } else {
            this.makeToastFaile(
              `Có ${result.failures.length} đơn hàng cập nhật thất bại`,
            );
            this.$emit('refresh', true);
          }
        } else {
          this.makeToastFaile(message || 'Có lỗi xảy ra khi cập nhật đơn hàng');
        }
      }
    },

    sumAmountTotal(order) {
      if (order.errors.length > 0) return 0;

      const {
        discountType,
        orderItems,
        discountAmount,
        customerShipFee,
        shipFee,
      } = order;
      const PERCENT_100 = 100;

      let totalPriceOrderItem = 0;
      let discountAmountTotal = 0;

      totalPriceOrderItem =
        orderItems &&
        orderItems.reduce(
          (sum, currentOrderItem) => sum + currentOrderItem.totalAmount,
          0,
        );

      if (discountType === ENUM.AMOUNT_TYPE.PERCENT) {
        discountAmountTotal =
          totalPriceOrderItem -
          totalPriceOrderItem * (discountAmount / PERCENT_100);
      } else {
        discountAmountTotal = totalPriceOrderItem - discountAmount;
      }

      return discountAmountTotal + customerShipFee - shipFee;
    },
    rows() {
      return this.importItems.length;
    },
    updateRows() {
      return this.updateItems.length;
    },
    openFile(name) {
      document.getElementById(name).click();
    },
    selectFile(event) {
      const files = event.target.files[0];
      const MAX_SIZE = 30 * 1024;

      if (!files) {
        this.textFile = '';
        return;
      }

      this.processBar = 0;
      if (!/(xls|xlsx|csv)$/.test(this.getExtension(files.name))) {
        this.clearFiles();
        return this.makeToastFaile(
          'Định dạng của file tải lên không chính xác. Vui lòng tải lên file có đuôi .xls .xlsx hoặc csv',
        );
      } else if (files.size > MAX_SIZE) {
        this.clearFiles();
        return this.makeToastFaile('Chỉ nhận file nhỏ hơn 30kB');
      }

      this.importItems = [];
      this.updateItems = [];
      this.file = files;
      this.textFile = files.name;
    },
    // mục đích là hiển thị lên UI để user biết sản phẩm tặng kèm đã được thêm vào
    addGiftsToOrderItems() {
      this.importItems.forEach((order) => {
        order.orderItems.forEach((item) => {
          if (item.gifts && item.gifts.length > 0) {
            item.gifts.forEach((gift) => {
              // Thêm gift vào orderItems
              order.orderItems.push({
                ...gift,
                belongOrderDetailId: item.belongOrderDetailId,
                parentProductId: item.productId,
                totalAmount: 0,
              });
            });
          }
        });
        let sttCounter = 1;
        order.orderItems.forEach((item) => {
          if (item.productType !== 1) {
            item.stt = -1; //stt của sản phẩm tặng kèm
          } else {
            item.stt = sttCounter++;
          }
        });
      });
    },
    uploadFile() {
      if (!this.btnDisable) {
        if (!this.importType) {
          return this.makeToastFaile('Vui lòng chọn loại import trước');
        }

        if (!this.file) {
          return this.makeToastFaile('Vui lòng chọn file Excel');
        }
        this.btnDisable = true;
        this.processBar = 0;
        this.importItems = [];
        this.updateItems = [];
        this.successCreateOrder = false;
        this.successUpdateOrder = false;

        const submitButton = this.$refs['up_excel'];
        this.$refs['up_excel'].innerHTML = '';
        submitButton.classList.add(
          'spinner',
          'spinner-primary',
          'spinner-md',
          'spinner-center',
          'px-7',
        );
        let formData = new FormData();
        const file = this.file;
        const route = this.$route;

        let path = route.path.split('/');
        path = 'upload/' + path[path.length - 2];

        formData.append('path', path);
        formData.append('mode', route.params.mode);
        formData.append('file', file);
        formData.append('importType', this.importType);

        const url = BASE_URL + 'orders/import-excel';

        axios
          .post(url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data;',
            },
            timeout: 10000 * 60,
          })
          .then((rs) => {
            this.processBar = 100;
            this.btnDisable = false;
            this.$nprogress.done();
            this.$refs['up_excel'].innerHTML =
              '<i class="fas fa-upload text-primary"></i>';
            submitButton.classList.remove(
              'spinner',
              'spinner-primary',
              'spinner-md',
              'spinner-center',
              'px-7',
            );

            if (rs.data.status) {
              if (this.importType === 'create') {
                this.importItems = [...rs.data.data].map((item) => {
                  const statusValidate =
                    item.errors.length > 0
                      ? STATUS_VALIDATE.INVALID
                      : STATUS_VALIDATE.READY;
                  return {
                    ...item,
                    onLoading: false,
                    statusValidate: statusValidate,
                  };
                });
                this.addGiftsToOrderItems();
              } else if (this.importType === 'update') {
                const allItems = [
                  ...rs.data.data.successes,
                  ...rs.data.data.failures,
                ];

                this.updateItems = allItems.map((item, index) => {
                  const statusValidate =
                    item.errors.length > 0
                      ? STATUS_VALIDATE.INVALID
                      : STATUS_VALIDATE.READY;

                  return {
                    ...item,
                    idOrder: item.id || `ROW_${index + 1}`,
                    codeShipName: item.codeShip || 'N/A',
                    errors: item.errors || [],
                    onLoading: false,
                    statusValidate: statusValidate,
                  };
                });
              }
            }
            this.makeToastSuccess('Đọc file thành công');
          })
          .catch((error) => {
            setTimeout(() => {
              this.btnDisable = false;
              this.$refs['up_excel'].innerHTML =
                '<i class="fas fa-upload text-primary"></i>';
              this.$nprogress.done();
              submitButton.classList.remove(
                'spinner',
                'spinner-primary',
                'spinner-md',
                'spinner-center',
                'px-7',
              );
              if (error) {
                const { message } = error.response.data;
                this.makeToastFaile(message);
              } else {
                this.makeToastFaile(
                  'Vui lòng chọn lại file hoặc kiểm tra kết nối mạng',
                );
              }
            }, 500);
          });
      } else {
        this.makeToastFaile('File đang được tải lên ...');
      }
    },
    getExtension(fname) {
      const pos = fname.lastIndexOf('.');
      const strlen = fname.length;
      let extension = '';
      if (pos != -1 && strlen != pos + 1) {
        let ext = fname.split('.');
        let len = ext.length;
        extension = ext[len - 1].toLowerCase();
      } else {
        return this.makeToastFaile('File không đúng định dạng');
      }
      return extension;
    },
    onRemovedItem(orderCode) {
      const findIndexBy = (items, orderCode) => {
        return items.findIndex((item) => item.orderCode === orderCode);
      };

      const index = findIndexBy(this.importItems, orderCode);
      if (index > -1) {
        this.importItems.splice(index, 1);
      }
    },

    onRemovedUpdateItem(idOrder) {
      const index = this.updateItems.findIndex(
        (item) => item.idOrder === idOrder,
      );
      if (index > -1) {
        this.updateItems.splice(index, 1);
      }
    },
    clearFiles() {
      this.importItems = [];
      this.updateItems = [];
      this.file = null;
      this.processBar = 0;
      if (this.$refs['file-input']) {
        this.$refs['file-input'].reset();
      }
      this.textFile = '';
      this.successCreateOrder = false;
      this.successUpdateOrder = false;
    },

    htmlGetStatusValidate(item, type, mode = 'create') {
      const isUpdate = mode === 'update';
      let name = '';

      switch (item.statusValidate) {
        case STATUS_VALIDATE.READY: {
          name =
            type === 'class'
              ? 'far fa-clock text-primary'
              : isUpdate
              ? 'Sẵn sàng cập nhật'
              : 'Sẵn sàng tạo mới';
          break;
        }
        case STATUS_VALIDATE.VALID: {
          name =
            type === 'class'
              ? 'fas fa-check-circle text-success'
              : isUpdate
              ? 'Cập nhật thành công'
              : 'Sẵn sàng tạo mới';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : 'Không hợp lệ';
          break;
        }
      }
      return name;
    },

    showOverlay(type) {
      if (type === 'create') return !this.hasError && this.importItems.length;
      if (type === 'update')
        return !this.hasErrorUpdate && this.updateItems.length;
      return false;
    },
    getLoading(type) {
      return type === 'create' ? this.onLoadingList : this.onLoadingListUpdate;
    },
    getItems(type) {
      return type === 'create' ? this.importItems : this.updateItems;
    },
    getSuccess(type) {
      return type === 'create'
        ? this.successCreateOrder
        : this.successUpdateOrder;
    },
    handleSubmit(type) {
      if (type === 'create') this.onCreateOrders();
      else this.onUpdateOrders();
    },

    popupImportExcelCreateOrder() {
      this.$bvModal.show('import-excel-create-orders');
    },
    makeToastSuccess(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'success',
        solid: true,
      });
    },
    makeToastFaile(message) {
      this.$bvToast.toast(message, {
        title: `Thông báo`,
        variant: 'danger',
        solid: true,
      });
    },
  },
};
</script>
<style lang="scss">
.order-import-excel {
  table.b-table[aria-busy='true'] {
    opacity: 0.6;
  }
}

#import-excel-create-orders {
  .modal-dialog.modal-xl {
    max-width: 95vw;
  }
}
</style>
